import { Controller } from "@hotwired/stimulus"

// Reveals an "Install app" affordance and drives installation.
// - Android / desktop Chromium: uses the beforeinstallprompt event captured globally
//   in application.js (window.fdDeferredInstallPrompt).
// - iOS Safari: there is no install prompt API, so the button instead opens an
//   "Add to Home Screen" instruction sheet (dialog#pwa-ios-modal).
// Hidden entirely when already running as an installed (standalone) app.
export default class extends Controller {
  connect() {
    if (this.isStandalone()) return // already installed — no affordance needed

    this.ios = this.isIOSSafari()
    if (this.ios) {
      this.element.hidden = false
    } else {
      if (window.fdDeferredInstallPrompt) this.element.hidden = false
      this.onAvail = () => this.element.hidden = false
      window.addEventListener("fd:installable", this.onAvail)
    }
    this.onInstalled = () => this.element.hidden = true
    window.addEventListener("appinstalled", this.onInstalled)
  }

  disconnect() {
    if (this.onAvail) window.removeEventListener("fd:installable", this.onAvail)
    window.removeEventListener("appinstalled", this.onInstalled)
  }

  async install(event) {
    event?.preventDefault()

    if (this.ios) {
      document.getElementById("pwa-ios-modal")?.setAttribute("open", "")
      return
    }

    const prompt = window.fdDeferredInstallPrompt
    if (!prompt) return
    prompt.prompt()
    await prompt.userChoice
    window.fdDeferredInstallPrompt = null
    this.element.hidden = true
  }

  isStandalone() {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    )
  }

  isIOSSafari() {
    const ua = window.navigator.userAgent
    // iPhone/iPod, plus iPadOS 13+ which reports as "MacIntel" with touch.
    const isIOSDevice =
      /iphone|ipad|ipod/i.test(ua) ||
      (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1)
    // Only Safari can "Add to Home Screen" on iOS; exclude Chrome/Firefox/Edge for iOS.
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios|chrome|android/i.test(ua)
    return isIOSDevice && isSafari
  }
}
